import numeral from 'numeral';

// ----------------------------------------------------------------------

type InputValue = string | number | null;

export function fNumber(number: InputValue) {
  return numeral(number).format();
}

export function fCurrency(number: InputValue) {
  const format =
    number !== null && number !== undefined ? numeral(number).format('$0,0.00') : '';

  return result(format, '.00');
}

export function fPercent(number: InputValue) {
  const format = number ? numeral(Number(number) / 100).format('0.0%') : '';

  return result(format, '.0');
}

export function fShortenNumber(number: InputValue) {
  const format = number ? numeral(number).format('0.00a') : '';

  return result(format, '.00');
}

export function fData(number: InputValue) {
  const format = number ? numeral(number).format('0.0 b') : '';

  return result(format, '.0');
}

function result(format: string, key = '.00') {
  const isInteger = format.includes(key);

  return isInteger ? format.replace(key, '') : format;
}

export function fillWithZeros(number: number, length: number): string {
  const numberString = number?.toString() ?? '';
  if (numberString.length >= length) {
    return numberString;
  }
  const zerosToAdd = length - numberString.length;
  const zeros = '0'.repeat(zerosToAdd);
  return zeros + numberString;
}

export const getNumberSeparators = (
  language: string = 'en'
): { decimalSeparator: string; thousandSeparator: string } => {
  let decimalSeparator;
  let thousandSeparator;

  if (language === 'es') {
    decimalSeparator = ',';
    thousandSeparator = '.';
  } else {
    decimalSeparator = '.';
    thousandSeparator = ',';
  }

  return { decimalSeparator, thousandSeparator };
};
